<template>
	<div>
		<div id="main-wrapper">
			<Header />
			<AppMain />
		</div>
	</div>
</template>

<script>
import Header from "@/components/fixedcomponents/header.vue";
import AppMain from "@/components/Layout/AppMain";

export default {
	name: "Layout",
	components: {
		Header,
		AppMain,
	},
	data() {
		return {};
	},
};
</script>
